var map = {
	"./2017-10-16.png": "JdMh",
	"./2017-10-19.png": "yB6b",
	"./2017-10-26.png": "8xwv",
	"./2017-10-28.png": "3bXf",
	"./2017-12-06.png": "aequ",
	"./2017-12-27.png": "BfkV",
	"./2018-01-29.png": "xCMF",
	"./2018-01-30.png": "XjkK",
	"./2019-05-08.png": "XK8l",
	"./2021-08-21.png": "Ejx7",
	"./2021-09-03.png": "bQa2",
	"./2021-09-05.png": "GPkP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9EkD";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/press nonrecursive \.png$
// module id = 9EkD
// module chunks = 1